import React, { FC } from 'react';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import Typography from 'src/components/Typography';
import Grid, { GridItem } from 'src/components/Grid';
import { styled } from '@mui/system';
import { colors } from 'src/themes/default';

const OptionsBlock = styled('div')({
    paddingLeft: '15px',

    '& > .MuiGrid-container': {
        border: '1px solid silver',
        padding: 0,
        marginTop: 0,

        '& > .MuiGrid-item': {
            border: '1px solid silver',
            padding: '2px',

            '& .MuiGrid-item': {
                // paddingTop: '16px',
            },
        },
    },
});

export interface OptionsSimpleTableProps {
    keyText: string;
    options?: ConstantsCodeType[];
    onlyValue?: boolean;
}

const OptionsSimpleTable: FC<OptionsSimpleTableProps> = (props) => {
    return (
        <Grid sx={{ paddingTop: 0, overflow: 'hidden', marginTop: '16px' }}>
            <GridItem cols={12}>
                <Typography variant="h3" sx={{ overflow: 'hidden' }}>{`${props.keyText}:`}</Typography>
            </GridItem>
            <GridItem cols={12}>
                <OptionsBlock>
                    <Grid sx={{ paddingTop: '0px', marginTop: '10px' }}>
                        {props.options &&
                            props.options.map((item) => (
                                <GridItem cols={12} key={String(item.value)}>
                                    {props.onlyValue ? (
                                        <Typography variant="body1" sx={{ color: colors.primary_O }}>
                                            {item.label}
                                        </Typography>
                                    ) : (
                                        <Grid sx={{ paddingTop: '0px', marginTop: '0px' }}>
                                            <GridItem cols={6}>
                                                <Typography variant="body1">{item.label}</Typography>
                                            </GridItem>
                                            <GridItem cols={6}>
                                                <Typography variant="body1" sx={{ color: colors.primary_O }}>
                                                    {item.value}
                                                </Typography>
                                            </GridItem>
                                        </Grid>
                                    )}
                                </GridItem>
                            ))}
                    </Grid>
                </OptionsBlock>
            </GridItem>
        </Grid>
    );
};

export default OptionsSimpleTable;
